import { render, staticRenderFns } from "./DevBuilder.vue?vue&type=template&id=2afc8c57&scoped=true"
import script from "./DevBuilder.vue?vue&type=script&lang=js"
export * from "./DevBuilder.vue?vue&type=script&lang=js"
import style0 from "./DevBuilder.vue?vue&type=style&index=0&id=2afc8c57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afc8c57",
  null
  
)

export default component.exports